import React, { useState } from 'react';
import { Box, Tabs, Tab, useTheme, useMediaQuery, Container } from '@mui/material';
import ImageInput from './ImageInput';
import GooglePhotoSelector from './GooglePhotoSelector';
import ImageGallery from './ImageGallery';

const styles = {
  tabContainer: {
    mt: 2,
    mb: 2,
    border: '2px dashed',
    borderColor: 'divider',
    borderRadius: 2,
    textAlign: 'center',
    width: '100%',
    boxSizing: 'border-box',
    mx: 0,
    px: { xs: 1, sm: 2 },
    py: { xs: 1, sm: 2 },
    overflow: 'hidden'
  },
  imageGallery: {
    mt: 4,
    mb: 2,
  },
  imageGalleryTitle: {
    mb: 2,
    color: 'text.secondary',
    display: 'flex',
    alignItems: 'center',
    gap: 1,
  },
  tabs: {
    '& .MuiTab-root': {
      fontSize: { xs: '0.75rem', sm: '0.875rem' },
      minWidth: { xs: 'auto', sm: 120 },
      px: { xs: 1, sm: 2 },
    }
  },
  mainContainer: {
    width: '100%',
    padding: 0,
    margin: 0,
    maxWidth: 'none',
    boxSizing: 'border-box'
  }
};

const ImageViewAndUpload = ({ existingImages, setExistingImages, selectedImages, setSelectedImages, allowEdit}) => {
  const [tabIndex, setTabIndex] = useState(0);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const handleTabChange = (event, newValue) => {
    setTabIndex(newValue);
  };

  const handleRemoveImage = (index, isExisting) => {
    if (isExisting) {
      setExistingImages(prev => {
        const newImages = [...prev];
        newImages.splice(index, 1);
        return newImages;
      });
    } else {
      setSelectedImages(prev => {
        const newImages = [...prev];
        URL.revokeObjectURL(newImages[index].preview);
        newImages.splice(index, 1);
        return newImages;
      });
    }
  };

  return (
    <Container disableGutters sx={styles.mainContainer}>
      <ImageGallery
        images={[...existingImages, ...selectedImages]}
        allowDelete={allowEdit}
        onDeleteImage={handleRemoveImage}
      />
      { allowEdit && (
        <>
          <Tabs 
            value={tabIndex} 
            onChange={handleTabChange} 
            aria-label="image upload tabs"
            variant={isMobile ? "fullWidth" : "standard"}
            sx={styles.tabs}
          >
            <Tab label="Upload from Device" />
            <Tab label="Google Photos" />
          </Tabs>
          <Box sx={styles.tabContainer}>
            {tabIndex === 0 && <ImageInput setSelectedImages={setSelectedImages} />}
            {tabIndex === 1 && <GooglePhotoSelector setSelectedImages={setSelectedImages} />}
          </Box> 
        </>)}
    </Container>
  );
};

export default ImageViewAndUpload; 